import { InstagramElementType } from "app/common/constants/structuredText"
import { DetailedHTMLProps, HTMLAttributes, PropsWithChildren, useEffect } from "react"

declare global {
  interface Window {
    instgrm: {
      Embeds: {
        process: () => void
      }
    }
  }
}

type InstagramElementProps = PropsWithChildren<{
  attributes: DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement>
  element: InstagramElementType
}>

export const InstagramElement = ({ attributes, children, element }: InstagramElementProps) => {
  useEffect(() => {
    window.instgrm && window.instgrm.Embeds.process()
  }, [])

  return (
    <div {...attributes} contentEditable={false}>
      <div dangerouslySetInnerHTML={{ __html: element.markup }} />
      {children}
    </div>
  )
}
